import "regenerator-runtime/runtime";
import React from "react";
import { render } from "react-dom";
import jQuery from "jquery";
import Media from "./utils/bases/media";
import MenuPhablet from "./menu-phablet/index";
import MenuDesktop from "./menu-desktop/index";
import PublicationApp from "./publications/components/app";
import "bootstrap";

import {
  checkStickyImage,
  getBaseUrl,
  query,
  queryAll,
  udpateTabSticking,
} from "./utils/utils";

// DIPF custom styles
// Only import for front facing site. We use a vanilla styled backend
if (jQuery("body.frontend#visual-portal-wrapper").length > 0) {
  import("./print.scss");

  // Custom bbf styling
  if (jQuery("body").data("subsite-id") === "bbf") {
    import("./bbf.scss");
  }

  // Custom Taetigkeitsbericht styling
  if (jQuery("body").data("subsite-id") === "bericht") {
    import("./taetigkeitsbericht.scss");
  }

  // Carousel Bootstrap pause button.
  if (jQuery(".carousel").length) {
    var carouselElement = document.getElementsByClassName("carousel")[0];
    var carousel = new bootstrap.Carousel(carouselElement, {
      interval: 6000,
      ride: "carousel",
    });

    setTimeout(() => {
      jQuery(".flickity-play-button").on("click", function () {
        if ($(this).hasClass("paused")) {
          $(this).removeClass("paused");
          // WTF BUG: https://github.com/orgs/twbs/discussions/35673#discussioncomment-4852893
          carousel.pause();
        } else {
          $(this).addClass("paused");
          carousel.cycle();
        }
      });
    });
  }

  // SEARCH LAYER
  let searchIsOpen = false;
  const searchLayer = query("#search-layer");
  const searchToggles = queryAll(".search-toggle");
  const searchInput = queryAll(".search-input");
  searchToggles.forEach((button) => {
    "use strict";
    button.addEventListener("click", (event) => {
      searchIsOpen = !searchIsOpen;
      searchLayer.setAttribute("aria-hidden", !searchIsOpen);
      searchToggles.forEach((button) =>
        button.setAttribute("aria-expanded", searchIsOpen),
      );
      $(searchInput).focus();
    });
  });

  let baseUrl = getBaseUrl();
  const logo = document.getElementById("portal-logo");
  // DESKTOP MENU
  // With js enabled we hide the the main nav - as it gets replaced by the react nav
  const el = document.getElementById("menu-desktop");
  el.style.display = "none";
  Media.on("above-l", function () {
    "use strict";
    // Desktop breakpoint -> we set the normal logo
    logo.children[0].src = baseUrl + "/@@images/logo";
    logo.children[0].style = "";
    // Load the react Desktop Menu
    render(<MenuDesktop />, el);
  });

  // PHABLET MENU
  Media.on("below-l", async function () {
    // Check if we have a sticky logo
    let jsonData = await checkStickyImage(baseUrl);
    if (jsonData) {
      // Mobile breakpoint -> we set the sticky logo
      logo.children[0].src = baseUrl + "/@@images/sticky_logo";
      logo.children[0].style = "width: 100px";
    }
    // Load the react Mobile Menu
    const el = document.getElementById("menu-phablet");
    render(<MenuPhablet />, el);
  });

  // store the hash (DON'T put this code inside the $() function, it has to be executed
  // right away before the browser can start scrolling!

  jQuery(function () {
    if (jQuery(".tabs-outer").length) {
      udpateTabSticking();

      jQuery(window).scroll(function () {
        udpateTabSticking();
      });
    }
    if (jQuery("h2.accordion").length) {
      import("./accordion");
    }
  });
}

// BACKEND Plone logged-in
if (jQuery("body.frontend#visual-portal-wrapper").length === 0) {
  // Backend styles only for dipf main website
  if (jQuery("body").data("subsite-id") === "dipf") {
    import("./dipf_backend.scss");
  }

  // diff views
  if (jQuery("body.template-iterate_diff, body.template-history").length) {
    import("./compare.css");
  }

  // Custom bbf styling
  if (jQuery("body").data("subsite-id") === "bbf") {
    import("./bbf_backend.scss");
  }

  // Load default bootstrap at the end
  import("./bootstrap.scss");
}

// Load staffmember publications
if (jQuery("body.portaltype-staffmember.template-view").length > 0) {
  // Set timeout as the accordion is not fully loaded
  setTimeout(() => {
    const el = document.getElementById("publications-root");
    if (el) {
      render(<PublicationApp hisid={el.getAttribute("data-hisid")} />, el);
    }
  }, 1000);
}

// Load project publications
if (jQuery("body.portaltype-projekt_dx.template-view").length > 0) {
  // Set timeout as the accordion is not fully loaded
  setTimeout(() => {
    const el = document.getElementById("publications-root");
    if (el) {
      render(
        <PublicationApp projekt_ids={el.getAttribute("data-projekt_ids")} />,
        el,
      );
    }
  }, 1000);
}

// Bildungsbericht
if (jQuery("body.template-bildungsbericht-frontpage").length > 0) {
  import("./bildungsbericht.scss");
}

if (jQuery(".image-map-container").length > 0) {
  import("./bildungsbericht.scss");
  import("./utils/imageMapResizer.min");
}

// Dipf PubDB with type-ahead
if (jQuery("body.template-erweiterte-suche").length > 0) {
  // Todo Webpack error
  //import("imports-loader?jQuery=jquery!devbridge-autocomplete");
  import("./publications-search/autocomplete_init");
  import("./publications-search/publication");
  import("./publications-search/publication.scss");
}

// BBF without type-ahead
if (jQuery("body.template-erweiterte-suche-bbf").length > 0) {
  import("./publications-search/publication");
  import("./publications-search/publication.scss");
}

if (jQuery("body.portaltype-publikation").length > 0) {
  import("./publications-search/publication.scss");
  import("./publications-search/publication_list");
}

if (jQuery("#calendar")) {
  import("./fullcalendar.scss");
}

if (jQuery(".moduletype-gallerymodule")) {
  import("./gallery_module/gallery");
  import("./gallery_module/gallery.scss");
}
